import Vue from 'vue'
import autosize from 'autosize'

Vue.directive('pml-autosize', {
    inserted (el) {
        autosize(el)
    }
})



// WEBPACK FOOTER //
// ./src/utils/directives/autosize.js